import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import PropTypes from 'prop-types';

import Button from 'shared/button';
import ManagedInput from 'components/form/managed_input';

export const RenameModal = ({ shadow, onClose, onRename }) => {
  const [name, setName] = useState(shadow.name);

  return (
    <Modal show onHide={onClose}>
      <Modal.Header closeButton>
        <Modal.Title>Rename to</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <ManagedInput
          autoFocus
          className="form-control"
          name="name"
          value={name}
          onValueChange={name => setName(name)}
        />
      </Modal.Body>
      <Modal.Footer>
        <Button.Cancel name="cancel" onClick={onClose} />
        <Button.Primary name="ok" onClick={() => onRename(name)}>
          Ok
        </Button.Primary>
      </Modal.Footer>
    </Modal>
  );
};

RenameModal.propTypes = {
  shadow: PropTypes.shape({
    name: PropTypes.string.isRequired,
  }).isRequired,
  onClose: PropTypes.func.isRequired,
  onRename: PropTypes.func.isRequired,
};
